import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #1c1c1c;
  border: 1px solid #ca7100;
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
`;

const Title = styled.h3`
  color: #fff;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: #bbb;
  margin-bottom: 1.5rem;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  width: 100%;
`;

const ConfirmBtn = styled.button`
  flex: 1; /* ✅ take equal space */
  background: linear-gradient(-45deg, #fed693, #ca7100);
  border: none;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(-45deg, #ca7100, #fed693);
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(202, 113, 0, 0.5);
  }
`;

const CancelBtn = styled.button`
  flex: 1; /* ✅ take equal space */
  background: #333;
  border: none;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #444;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(255, 255, 255, 0.2);
  }
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: #333;
  margin: 1rem 0; /* ✅ space around the line */
`;

const Highlight = styled.span`
  color: #fed693; /* ✅ golden yellow */
  font-weight: 600;
`;

export default function ConfirmLocationModal({
  location,
  onConfirm,
  onCancel,
}) {
  if (!location) return null;

  return (
    <Overlay>
      <Modal>
        <Title>CONFIRM LOCATION</Title>

        <Message>
          Do you want to book at <Highlight>{location.title}</Highlight>,{" "}
          <Highlight>{location.town}?</Highlight>
        </Message>
        {/* ✅ Divider line before buttons */}
        <Divider />

        <ButtonRow>
          <CancelBtn onClick={onCancel}>Cancel</CancelBtn>
          <ConfirmBtn onClick={() => onConfirm(location)}>Yes</ConfirmBtn>
        </ButtonRow>
      </Modal>
    </Overlay>
  );
}
